export const FavourTournamentLogEvent = {
  // [호불호 결과] 화면 진입
  FW_RESULT_VIEWED: {amp: 'FW Result - Viewed', ga: 'fw_result_visit'},
  // [호불호 결과] 다음 버튼 클릭
  FW_RESULT_NEXT_BUTTON_CLICKED: {amp: 'FW Result - Next Button Clicked', ga: 'click_next'},
  // [호불호 케미 온보딩] 화면 진입
  FW_CHEMI_ONBOARDING_VIEWED: {amp: 'FW Chemi Onboarding - Viewed', ga: 'fw_onboarding_visit'},
  // [호불호 케미 온보딩] 결과 비교하기 버튼 클릭
  FW_CHEMI_ONBOARDING_COMPARE_BUTTON_CLICKED: {amp: 'FW Chemi Onboarding - Compare Button Clicked', ga: 'click_compare'},
  // [호불호 케미 온보딩] 타입스 홈으로 버튼 클릭
  FW_CHEMI_ONBOARDING_HOME_BUTTON_CLICKED: {amp: 'FW Chemi Onboarding - Home Button Clicked', ga: 'click_home'},
  // [호불호 케미 친구 선택] 화면 진입
  FW_CHEMI_FRIEND_SELECT_VIEWED: {amp: 'FW Chemi Friend Select - Viewed', ga: 'fw_chemi_friend_select_visit'},
  // [호불호 케미 친구 선택] 친구초대 버튼 클릭
  FW_CHEMI_FRIEND_SELECT_INVITE_BUTTON_CLICKED: {amp: 'FW Chemi Friend Select - Invite Button Clicked', ga: 'click_invite'},
  // [호불호 케미 친구 선택 모달] 모달 open 
  FW_CHEMI_FRIEND_SELECT_MODAL_IMPRESSION: {amp: 'FW Chemi Friend Select Modal - Impression', ga: 'modal_impression'},
  // [호불호 케미 친구 선택 모달] 링크 복사 클릭 
  FW_CHEMI_FRIEND_SELECT_MODAL_COPY_BUTTON_CLICKED: {amp: 'FW Chemi Friend Select Modal - Copy Button Clicked', ga: 'click_link_copy'},
  // [호불호 케미 친구 선택 모달] 카카오 전송 클릭 
  FW_CHEMI_FRIEND_SELECT_MODAL_KAKAO_BUTTON_CLICKED: {amp: 'FW Chemi Friend Select Modal - Kakao Button Clicked', ga: 'click_kakao'},
  // [호불호 케미 결과 - Empty] 화면 진입
  FW_CHEMI_EMPTY_RESULT_VIEWED: {amp: 'FW Chemi Empty Result - Viewed', ga: 'fw_chemi_empty_result_visit'},
  // [호불호 케미 결과 - Empty] 링크 복사 클릭
  FW_CHEMI_EMPTY_RESULT_COPY_BUTTON_CLICKED: {amp: 'FW Chemi Empty Result - Copy Button Clicked', ga: 'click_copy'},
  // [호불호 케미 결과 - Empty] 카카오 전송 클릭
  FW_CHEMI_EMPTY_RESULT_KAKAO_BUTTON_CLICKED: {amp: 'FW Chemi Empty Result - Kakao Button Clicked', ga: 'click_kakao'},
  // [호불호 케미 결과] 화면 진입
  FW_CHEMI_RESULT_VIEWED: {amp: 'FW Chemi Result - Viewed', ga: 'fw_chemi_result_visit'},
  // [호불호 케미 결과] 분석 카드 노출
  FW_CHEMI_RESULT_CARD_IMPRESSION: {amp: 'FW Chemi Result - Card Impression', ga: 'card_impression'},
  // [호불호 케미 결과] 다른 호불호 월드컵 하러 가기 버튼 클릭
  FW_CHEMI_RESULT_MORE_FW_QUIZ_BUTTON_CLICKED: {amp: 'FW Chemi Result - More FW Quiz Button Clicked', ga: 'click_more_quiz'},
  // (웹 only) [호불호 케미 결과] 앱 설치 버튼 클릭
  FW_CHEMI_RESULT_APP_INSTALL_CLICKED: {amp: 'FW Chemi Result - App Install Clicked', ga: 'click_install_app'},
  // (웹 only) [호불호 케미 친구 입장] 화면 진입
  FW_CHEMI_JOIN_VIEWED: {amp: 'FW Chemi Join - Viewed', ga: 'fw_chemi_join_visit'},
  // (웹 only) [호불호 케미 친구 입장] 친구랑 내 결과 비교하기 버튼 클릭
  FW_CHEMI_JOIN_COMPARE_BUTTON_CLICKED: {amp: 'FW Chemi Join - Compare Button Clicked', ga: 'click_compare'},
  // (웹 only) [호불호 케미 친구 입장] 로그인 모달 open
  FW_CHEMI_JOIN_LOGIN_MODAL_IMPRESSION: {amp: 'FW Chemi Join Login Modal - Impression', ga: 'modal_impression'},
  // (웹 only) [호불호 케미 친구 입장] 로그인 모달에서 버튼 클릭
  FW_CHEMI_JOIN_LOGIN_MODAL_LOGIN_BUTTON_CLICKED: {amp: 'FW Chemi Join Login Modal - Login Button Clicked', ga: 'click_login'},
  // (웹 only) [호불호 케미 친구 입장 - 퀴즈] 질문지 화면 진입
  FW_CHEMI_QUIZ_QUESTIONNAIR_VIEWED: {amp: 'FW Chemi Quiz - Questionnair Viewed', ga: 'questionnair_viewed'},
  // (웹 only) [호불호 케미 친구 입장 - 퀴즈] submit
  FW_CHEMI_QUIZ_SUBMIT: {amp: 'FW Chemi Quiz - Submit', ga: 'submit'},
  // (웹 only) [호불호 케미 친구 입장 - 분석중] 화면 진입
  FW_CHEMI_STAGING_VIEWED: { amp: 'FW Chemi Staging - Viewed', ga: 'fw_chemi_staging_visit' },
  // [호불호 케미 리스트] 화면 진입
  FW_CHEMI_LIST_VIEWED: { amp: 'FW Chemi List - Viewed', ga: 'fw_chemi_list_viewed' },
  // [호불호 케미 리스트] 링크 복사 클릭
  FW_CHEMI_LIST_COPY_BUTTON_CLICKED: { amp: 'FW Chemi List - Copy Button Clicked', ga: 'fw_chemi_list_click_copy' },
  // [호불호 케미 리스트] 카카오 전송 클릭
  FW_CHEMI_LIST_KAKAO_BUTTON_CLICKED: { amp: 'FW Chemi List - Kakao Button Clicked', ga: 'fw_chemi_list_click_kakao' },
  // [호불호 케미 리스트] 케미 클릭
  FW_CHEMI_LIST_CHEMI_CLICKED: { amp: 'FW Chemi List - Chemi Clicked', ga: 'fw_chemi_list_click_kakao' },
}